<template>
  <div
    ref="menuRef"
    class="relative inline-block"
  >
    <div @click.stop="toggle">
      <slot
        name="trigger"
        :open="isOpen"
      />
    </div>

    <Transition
      enter-from-class="opacity-0 -translate-y-1"
      leave-to-class="opacity-0 -translate-y-1"
      enter-active-class="transition duration-150 ease-out"
      leave-active-class="transition duration-100 ease-in"
    >
      <div
        v-show="isOpen"
        class="absolute top-full z-50 mt-1"
        :class="align === 'right' ? 'right-0' : 'left-0'"
      >
        <div class="min-w-[11rem] bg-white shadow-lg border border-gray-200 rounded-lg py-1 flex flex-col">
          <slot :close="close" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { ref, useTemplateRef } from 'vue';

withDefaults(
  defineProps<{
    align?: 'left' | 'right';
  }>(),
  {
    align: 'right',
  },
);

const isOpen = ref(false);
const menuRef = useTemplateRef('menuRef');

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const close = () => {
  isOpen.value = false;
};

onClickOutside(menuRef, () => {
  isOpen.value = false;
});
</script>
